import { questionAndAnswerSets } from './jsonParsers/questions';
import { addRolesToQuestionSet, createQuestionSetFromSchema } from './helper';
import { roles } from './jsonParsers/roles';

const QuestionSets = {
    'Select Your Industry': createQuestionSetFromSchema(questionAndAnswerSets, roles[0].English),
};       

addRolesToQuestionSet(QuestionSets, roles, questionAndAnswerSets);

export default QuestionSets;
